var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"new-app"},[_c('dg-toasters',{attrs:{"notifications":_vm.toasters},on:{"on-close":_vm.onToasterClose}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }